"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            onlyPopular: true,
        };
        _this.toggleIsOpened = _this.toggleIsOpened.bind(_this);
        _this.togglePopular = _this.togglePopular.bind(_this);
        return _this;
    }
    Select.prototype.togglePopular = function () {
        this.setState({
            onlyPopular: !this.state.onlyPopular,
        });
    };
    Select.prototype.toggleIsOpened = function () {
        if (!this.props.canBeOpened) {
            return;
        }
        this.props.toggle();
    };
    Select.prototype.render = function () {
        var _a = this.props, value = _a.value, label = _a.label, options = _a.options, onChange = _a.onChange, canBeOpened = _a.canBeOpened, isVisible = _a.isVisible, isOpened = _a.isOpened, withPopular = _a.withPopular;
        var onlyPopular = this.state.onlyPopular;
        var selected = options.filter(function (o) { return o.id === value; })[0];
        if (!isVisible) {
            return null;
        }
        var filteredOptions = options;
        var showPopularitySwitcher = withPopular;
        if (withPopular && onlyPopular) {
            filteredOptions = filteredOptions.filter(function (o) { return o.is_popular; });
        }
        if (withPopular && filteredOptions.length === 0 && options.length !== 0) {
            console.warn('Нет ни одной популярной модели!');
            showPopularitySwitcher = false;
            filteredOptions = options;
        }
        return (React.createElement("div", { className: "tradein-estimate__collapse-item " + (isOpened && canBeOpened ? 'tradein-estimate__collapse-item_opened' : '') },
            React.createElement("div", { className: "tradein-estimate__collapse-header", onClick: this.toggleIsOpened },
                React.createElement("div", { className: "tradein-estimate__collapse-title" }, label),
                React.createElement("div", { className: "tradein-estimate__collapse-value" }, !!selected ? selected.title : '')),
            React.createElement("div", { className: "tradein-estimate__collapse-body" },
                React.createElement("ul", { className: "tradein-estimate__collapse-list" },
                    filteredOptions.map(function (option) { return (React.createElement("li", { key: option.id, onClick: function () { return onChange(option.id); }, className: "tradein-estimate__collapse-list-item " + (option.id === value ? 'tradein-estimate__collapse-list-item_active' : '') },
                        React.createElement("span", null, option.title))); }),
                    !!this.props.withPopular && showPopularitySwitcher ? (React.createElement("li", { style: { color: '#27509B', cursor: 'pointer', fontWeight: 'bold' }, className: 'tradein-estimate__collapse-list-item', onClick: this.togglePopular },
                        React.createElement("span", null, onlyPopular ? 'Все модели' : 'Только популярные'))) : null))));
    };
    Select.defaultProps = {
        options: [],
        canBeOpened: false,
        withPopular: false,
    };
    return Select;
}(React.PureComponent));
exports.default = Select;
